module.exports = __webpack_public_path__ + "static/media/shape.e6a01d39.svg";